import { Box, Typography } from '@mui/material';
import { FC, useCallback, useEffect, useState } from 'react';
// component
import ClearComponent from 'components/common/ClearComponent';
import RadioGroupController from 'controller/RadioGroupController';
// interfaces, constants, helper, graphql
import { renderTabletCoating } from 'lib/helper';
import { HTTP_STATUS, OPTIONAL_TEXT } from 'constants/index';
import { flexCenterJustifyBetween } from 'theme/styleConstant';
import { RadioGroupControllerExtendedProps, TabletCoatingRadioGroupProps } from 'interfaces';
import { TabletCoatingsPayload, useFindAllTabletCoatingLazyQuery } from 'generated/graphql';

const TabletCoatingRadioGroup: FC<TabletCoatingRadioGroupProps> = ({
  name,
  title,
  productType,
  showTitle = true,
  isRequired = false,
  loading: getLoading,
  onClear,
}) => {
  const [options, setOptions] = useState<RadioGroupControllerExtendedProps[]>([]);

  const [findAll, { loading: findAllLoading }] = useFindAllTabletCoatingLazyQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,

    onCompleted: (data) => {
      const { findAllTabletCoating } = data;
      const { response, data: tabletCoating } = findAllTabletCoating || {};
      const { status } = response || {};
      if (status === HTTP_STATUS.SUCCESS) {
        setOptions(renderTabletCoating(tabletCoating as TabletCoatingsPayload['data']));
      } else {
        setOptions([]);
      }
    },

    onError: () => {
      setOptions([]);
    },
  });

  const fetchTabletCoating = useCallback(async () => {
    if (productType) {
      await findAll({
        variables: {
          findAllTabletCoatingInput: {
            paginationOptions: {
              limit: 10,
              page: 1,
            },
            productType,
          },
        },
      });
    }
  }, [findAll, productType]);

  useEffect(() => {
    fetchTabletCoating();
  }, [fetchTabletCoating]);

  const loading = findAllLoading || getLoading;

  return (
    <RadioGroupController
      name={name}
      title={
        onClear ? (
          <Box sx={flexCenterJustifyBetween}>
            <Box>
              {title}
              <ClearComponent
                onClick={() => {
                  onClear && onClear();
                }}
              />
            </Box>
            <Typography color="primary">{OPTIONAL_TEXT}</Typography>
          </Box>
        ) : (
          title
        )
      }
      loaderRows={1}
      loading={loading}
      loaderColumns={4}
      options={options}
      showTitle={showTitle}
      isRequired={isRequired}
    />
  );
};

export default TabletCoatingRadioGroup;
